import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var SvgIconRoot = styled(Svg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: content-box;\n  color: ", ";\n  display: inline-block;\n  fill: currentColor;\n  font-size: ", ";\n  height: 1em;\n  width: 1em;\n"], ["\n  box-sizing: content-box;\n  color: ", ";\n  display: inline-block;\n  fill: currentColor;\n  font-size: ", ";\n  height: 1em;\n  width: 1em;\n"])), function (_a) {
    var iconColor = _a.iconColor, theme = _a.theme;
    if (typeof iconColor === 'undefined' || iconColor === 'inherit' || typeof theme.color === 'undefined') {
        return 'inherit';
    }
    if (typeof theme.color[iconColor] !== 'undefined') {
        return theme.color[iconColor];
    }
    return iconColor;
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    if (typeof theme.component === 'undefined') {
        return 'inherit';
    }
    return theme.component.icon[size].fontSize;
});
export var SvgIcon = forwardRef(function (props, ref) {
    var _a = props.iconColor, iconColor = _a === void 0 ? 'inherit' : _a, _b = props.size, size = _b === void 0 ? 'md' : _b, otherProps = __rest(props, ["iconColor", "size"]);
    return React.createElement(SvgIconRoot, __assign({ iconColor: iconColor, ref: ref, size: size }, otherProps));
});
SvgIcon.displayName = 'SvgIcon';
var templateObject_1;
//# sourceMappingURL=SvgIcon.js.map